<script lang="ts">
	import { storeMobileMenu } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { onNavigate } from '$app/navigation'

	const scope = getContextScope(),
		pages = [
			{ icon: 'questions', link: `/${scope}/centro-de-ayuda`, text: $t`Help center` },
			{ icon: 'info', link: `/${scope}/contact`, text: $t`Contact and tracking` },
			{ icon: 'hello', link: `/${scope}/blog`, text: $t`News and updates` },
			{ icon: 'leaf', link: `/${scope}/sostenibilidad`, text: $t`Sustainability` },
			{ icon: 'badge', link: `/${scope}/brands`, text: $t`Our brands` },
			{ icon: 'us', link: `/${scope}/quienes-somos`, text: $t`About us` },
		]

  onNavigate(() => {
    $storeMobileMenu = false
  })
</script>


<div class="tab-us">
	<div class="tab-us__inner">
		{#each pages as page}
			<a href="{page.link}" class="tab-us__link">
				<span class="icon icon-{page.icon}"></span>{page.text}
			</a>
		{/each}
	</div>
</div>


<style lang="scss">
  .tab-us {
    &__inner {
      @media (min-width: 769px) {
        margin-top: 25px;
      }

      @media (min-width: 1025px) {
        display: flex;
      }
    }

    &__link {
      display: block;
      color: black;
      padding: 20px 20px;
      border-bottom: 1px solid var(--grey);

      @media (min-width: 1025px) {
        border: none;
      }

      &:hover {
        background: var(--grey);

        @media (min-width: 1025px) {
          background: var(--main);
          color: white;
        }
      }

      span {
        display: inline-block;
        font-size: 18px;
        margin-right: 12px;
        margin-bottom: -2px;
      }
    }
  }
</style>